import { createApp } from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import SendDocumentBlock from './SendDocumentBlock'

const el = ".nyk-component--send-document-block";

export default function () {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach(async (SendDocumentBlockDOM) => {
            const formId = SendDocumentBlockDOM.getAttribute('data-id')
            const formGuid = SendDocumentBlockDOM.getAttribute('data-form-guid')
            const apiPath = SendDocumentBlockDOM.getAttribute('data-api-path')
            const advisorsSearchApiPath = SendDocumentBlockDOM.getAttribute('data-advisors-search-api-path')
            const siteKey = SendDocumentBlockDOM.getAttribute('data-recaptcha-site-key')
            const antiForgeryToken = SendDocumentBlockDOM.getAttribute('data-anti-forgery-token')
            const labelsString = SendDocumentBlockDOM.getAttribute('data-labels')
            const labels = labelsString ? JSON.parse(decodeURIComponent(labelsString)) : {};
            const allowFileUpload = SendDocumentBlockDOM.getAttribute('data-allow-file-upload') === 'true'
            const allowInternationalNumber = SendDocumentBlockDOM.getAttribute('data-allow-international-number') === 'true'
            const allowedFileTypes = SendDocumentBlockDOM.getAttribute('data-allowed-file-types');
            const maxFileSizeInBytes = SendDocumentBlockDOM.getAttribute('data-max-file-size-in-bytes') ? Number(SendDocumentBlockDOM.getAttribute('data-max-file-size-in-bytes')) : null;
            const receiverEmailValidDomainsString = SendDocumentBlockDOM.getAttribute('data-receiver-email-valid-domains');
            const contactAdvisorBlockId = SendDocumentBlockDOM.getAttribute('data-contact-advisor-block-id');
            const receiverEmailValidDomains = receiverEmailValidDomainsString ? JSON.parse(decodeURIComponent(receiverEmailValidDomainsString)) : null;

            const component = createApp(SendDocumentBlock, {
                formId,
                formGuid,
                apiPath,
                advisorsSearchApiPath,
                antiForgeryToken,
                labels,
                allowFileUpload,
                allowInternationalNumber,
                allowedFileTypes,
                maxFileSizeInBytes,
                receiverEmailValidDomains,
                contactAdvisorBlockId
            })
            component.use(VueReCaptcha, { siteKey })
            component.mount(SendDocumentBlockDOM)
        })
    }
}